(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  function init() {
    const targets = document.querySelectorAll(
      '.template-suffix-productpage-improved .product__info-container > .product__text.caption-with-letter-spacing:not(.product__text--vendor)'
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    targets.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
